import styled from 'styled-components';

const Root = styled.div`
  user-select: none;
  height: 100%;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--tonal-blue);
  color: var(--filled-blue-deep);
  border-radius: 0.25rem;
  padding: 0 1rem;
  font-size: 0.875rem;
  position: relative;
  .material-symbols-rounded {
    font-variation-settings: 'FILL' 1, 'wght' 600;
    font-size: 1rem;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(30%, -30%);
    color: var(--filled-red);
    background-color: var(--tonal-deep-red);
    border-radius: 50%;
    opacity: 0;
    height: 1.25rem;
    width: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    background-color: var(--tonal-deep-blue);
    .material-symbols-rounded {
      opacity: 1;
      &:hover {
        color: var(--bw-inverse);
        background-color: var(--filled-red);
      }
    }
  }
`;

interface Props {
  selectedItem: string;
  removeJobtype: (selectedItem: string) => void;
  name: string;
}

const JobtypeChip = ({ selectedItem, removeJobtype, name }: Props) => {
  return (
    <Root className='chip'>
      {name}
      <span
        className='material-symbols-rounded' //
        onClick={() => removeJobtype(selectedItem)}
        role='button'
        tabIndex={0}
      >
        close
      </span>
    </Root>
  );
};

export default JobtypeChip;
